module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';

	var EXO_UDID = require('../../../../../../common-components/verification-form/exo-udid')(fox);

	fox.registerWidget('Promo_Studios', {

		configure: function () {
			this.apiInProgress = false;

			this.registerOptions('', {
				widgets: {
					regForm: {
						widget: 'Form',
						loadValuesOnRun: false,
						customVisualHandling: true,
						formElements: {
							studioName: {
								element: '[name="studioName"]',
								autoApply: true,
								exchangeErrorClass: true,
								validateOnChange: true,
								validate: [{
									validator: 'length',
									options: {min: 1},
									message: 'This field is required'
								},{
									validator: 'regexp',
									options: {regexp: /^[\w\d\s\-_]+$/i},
									message: 'Wrong string format'
								}]
							},
							contactName: {
								element: '[name="contactName"]',
								autoApply: true,
								exchangeErrorClass: true,
								validateOnChange: true,
								validate: [{
									validator: 'length',
									options: {min: 1},
									message: 'This field is required'
								},{
									validator: 'regexp',
									options: {regexp: /^[\w\d\s\-_]+$/i},
									message: 'Wrong string format'
								}]
							},
							'consent_tos': {
								element: '[name="consent_tos"]',
								autoApply: true
							},
							'consent_marketing': {
								element: '[name="consent_marketing"]',
								autoApply: true,
								value: (fox.getEnv('defaultMarketingConsentValue') !== 'true'),
								defaultValue: (fox.getEnv('defaultMarketingConsentValue') !== 'true'),
							},
							email: {
								element: '[name="email"]', 
								autoApply: true,
								exchangeErrorClass: true,
								validateOnChange: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}]
							}
						},
						submit: {
							event: 'click',
							target: '#send-button'
						},
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							requiredFields: ['studioName', 'contactName', 'email', 'consent_tos'],
							hangClassLocation: 'parentNode',
							successClass: 'success',
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'This field is required'
							}]
						},
						hooks: {
							onSubmit: '@parent:onFormSubmit',
							onStopPrepareValues: function () {
								this._preparedValues.type = 'agency';
							},
							onResponse: '@parent:onFormResponse'
						}
					},
					recaptcha: {
						widget: 'RecaptchaFox'
					}
				},
				handleWom: {
					formNotValid: {
						event: 'formNotValid',
						widget: '#regForm #validator',
						callback: 'formNotValid'
					},
					elementsUpdated: {
						widget: '#regForm',
						event: 'elementsUpdated',
						callback: 'checkMarketingConsent'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		onFormResponse: function (res) {
			const CAPTCHA_ERROR_CODES = [60, 6030, 6031, 6032];
			this.$btn.removeClass('spin');
			var w, $el, f = this.rwom1('#regForm');

			if (res.answer.status === false) {
				if (fox.inArray(CAPTCHA_ERROR_CODES, res.answer.code) && this._recaptcha.isNeed()) {
					this._recaptcha.load('onError');
				}

				switch (res.answer.code) {
					case 5002:
						w = f.wom1('#email');

						if (w && ($el = $(w.formElement))) {
							$el.parent()
								.addClass('error')
								.find('.message')
								.text(res.answer.reason);
						}
						break;
					case 5003:
						w = f.wom1('#studioName');

						if (w && ($el = $(w.formElement))) {
							$el.parent()
								.addClass('error')
								.find('.message')
								.text(res.answer.reason);
						}
						break;
				}
			} else if (res.answer.response && res.answer.response.clientId) {
				//debugger;
				window.location.assign(['https://agency.', window.location.host, '/registration/step2'].join(''));
			}

			this.apiInProgress = false;
		},

		addedToDom: function () {
			this.$btn = $(this.dom1('#send-button span'));
			this._recaptcha = this.wom1('#recaptcha');

			if (this._recaptcha.isNeed()) {
				this._recaptcha.load();
			}
		},

		formNotValid: function (data) {
			var f = this.rwom1('#regForm');

			fox.each(data.errorStack, function (val, key) {
				var 
					$mNode,
					w = f.wom1(['#', key].join(''));

				if (w) {
					$mNode = $(w.formElement.parentNode).find('.message');

					var res = $mNode && $mNode.text(val.shift().message);
				}
			}, this);
		},

		onFormSubmit: function () {
			var api = this.getApi('regApi', {
				method: 'registration.register',
				httpMethod: 'post',
				encodePost: true,
				'handleWom.onResponse': {
					event: ['success', 'error', 'failure'],
					widget: '@this',
					callback: '@parent:onFormResponse'
				}
			});
			var formData = this.rwom1('#regForm').collectData();

			if (!formData.consent_tos) {
				this.formNotValid({errorStack: {'consent_tos': 'You must agree to the Agency Agreement'}});
				return;
			}

			if (this.apiInProgress) {
				return;
			}

			const captchaPromise = this._recaptcha.isNeed()
				? this._recaptcha.getToken('register')
				: Promise.resolve(null);

			this.$btn.addClass('spin');

			Promise.all([this.getUDID(), captchaPromise]).then(([_udid, captchaToken]) => {
				formData.udid = _udid;

				if (this._recaptcha.isNeed()) {
					if (this._recaptcha.captchaVariant === 'invisible') {
						formData['g-recaptcha-invisible-response'] = captchaToken || '';
					} else {
						if (!captchaToken) {
							this.$btn.removeClass('spin');
							return;
						}
						formData['g-recaptcha-response'] = captchaToken;
					}
				}

				api.send(formData);
				this.apiInProgress = true;
			});
		},

		getAuthapi: function () {
			return this.getApi('authApi', {
				method: 'studio.authorizer.auth',
				address: ['http://agency.', window.location.host, '/api.php'].join(''),
				'handleWom.onResponse': {
					event: 'success',
					widget: '@this',
					callback: function () {
						window.location.assign(['https://agency.', window.location.host, '/registration/step2'].join(''));
					}
				}
			});
		},

		deactivate: function () {
			this.callParent('deactivate', arguments);

			this.dispatchEvent('sitepage_unmounted');
		},

		checkMarketingConsent: function() {
			if (fox.getEnv('defaultMarketingConsentValue') === 'true') {
				this.wom1('#regForm #consent_marketing').setValue(true);
			}
		},
		
		getUDID: function() {
            return EXO_UDID.getShortUid();
		}

	});

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../promo/widget/promo/studios.js
// module id = 548
// module chunks = 2